
const LikeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={19}
    viewBox="0 0 21 19"
    fill="none"
    {...props}
  >
    <path
      d="M10.6172 18.2131C10.3839 18.2131 10.1464 18.1714 9.90469 18.0881C9.66302 18.0048 9.45052 17.8714 9.26719 17.6881L7.54219 16.1131C5.77552 14.4964 4.17969 12.8923 2.75469 11.3006C1.32969 9.70892 0.617188 7.95475 0.617188 6.03809C0.617188 4.47142 1.14219 3.16309 2.19219 2.11309C3.24219 1.06309 4.55052 0.538086 6.11719 0.538086C7.00052 0.538086 7.83385 0.725586 8.61719 1.10059C9.40052 1.47559 10.0672 1.98809 10.6172 2.63809C11.1672 1.98809 11.8339 1.47559 12.6172 1.10059C13.4005 0.725586 14.2339 0.538086 15.1172 0.538086C16.6839 0.538086 17.9922 1.06309 19.0422 2.11309C20.0922 3.16309 20.6172 4.47142 20.6172 6.03809C20.6172 7.95475 19.9089 9.71309 18.4922 11.3131C17.0755 12.9131 15.4672 14.5214 13.6672 16.1381L11.9672 17.6881C11.7839 17.8714 11.5714 18.0048 11.3297 18.0881C11.088 18.1714 10.8505 18.2131 10.6172 18.2131ZM9.66719 4.63809C9.18385 3.95475 8.66719 3.43392 8.11719 3.07559C7.56719 2.71725 6.90052 2.53809 6.11719 2.53809C5.11719 2.53809 4.28385 2.87142 3.61719 3.53809C2.95052 4.20475 2.61719 5.03809 2.61719 6.03809C2.61719 6.90475 2.92552 7.82559 3.54219 8.80059C4.15885 9.77559 4.89635 10.7214 5.75469 11.6381C6.61302 12.5548 7.49635 13.4131 8.40469 14.2131C9.31302 15.0131 10.0505 15.6714 10.6172 16.1881C11.1839 15.6714 11.9214 15.0131 12.8297 14.2131C13.738 13.4131 14.6214 12.5548 15.4797 11.6381C16.338 10.7214 17.0755 9.77559 17.6922 8.80059C18.3089 7.82559 18.6172 6.90475 18.6172 6.03809C18.6172 5.03809 18.2839 4.20475 17.6172 3.53809C16.9505 2.87142 16.1172 2.53809 15.1172 2.53809C14.3339 2.53809 13.6672 2.71725 13.1172 3.07559C12.5672 3.43392 12.0505 3.95475 11.5672 4.63809C11.4505 4.80475 11.3089 4.92975 11.1422 5.01309C10.9755 5.09642 10.8005 5.13809 10.6172 5.13809C10.4339 5.13809 10.2589 5.09642 10.0922 5.01309C9.92552 4.92975 9.78385 4.80475 9.66719 4.63809Z"
      fill="#BAB8B8"
    />
  </svg>
);

const NextIcon = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

const PrevIcon = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

const SaveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_12692_101313"
      style={{
        maskType: 'alpha'
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={25}
      height={25}
    >
      <rect x={0.980469} y={0.5} width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_12692_101313)">
      <path
        d="M5.98047 21.5V5.5C5.98047 4.95 6.1763 4.47917 6.56797 4.0875C6.95964 3.69583 7.43047 3.5 7.98047 3.5H17.9805C18.5305 3.5 19.0013 3.69583 19.393 4.0875C19.7846 4.47917 19.9805 4.95 19.9805 5.5V21.5L12.9805 18.5L5.98047 21.5ZM7.98047 18.45L12.9805 16.3L17.9805 18.45V5.5H7.98047V18.45Z"
        fill="#BAB8B8"
      />
    </g>
  </svg>
);

const ShareIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={20}
    viewBox="0 0 19 20"
    fill="none"
    {...props}
  >
    <path
      d="M15.2031 20C14.3698 20 13.6615 19.7083 13.0781 19.125C12.4948 18.5417 12.2031 17.8333 12.2031 17C12.2031 16.9 12.2281 16.6667 12.2781 16.3L5.25313 12.2C4.98646 12.45 4.67812 12.6458 4.32812 12.7875C3.97813 12.9292 3.60313 13 3.20312 13C2.36979 13 1.66146 12.7083 1.07812 12.125C0.494792 11.5417 0.203125 10.8333 0.203125 10C0.203125 9.16667 0.494792 8.45833 1.07812 7.875C1.66146 7.29167 2.36979 7 3.20312 7C3.60313 7 3.97813 7.07083 4.32812 7.2125C4.67812 7.35417 4.98646 7.55 5.25313 7.8L12.2781 3.7C12.2448 3.58333 12.224 3.47083 12.2156 3.3625C12.2073 3.25417 12.2031 3.13333 12.2031 3C12.2031 2.16667 12.4948 1.45833 13.0781 0.875C13.6615 0.291667 14.3698 0 15.2031 0C16.0365 0 16.7448 0.291667 17.3281 0.875C17.9115 1.45833 18.2031 2.16667 18.2031 3C18.2031 3.83333 17.9115 4.54167 17.3281 5.125C16.7448 5.70833 16.0365 6 15.2031 6C14.8031 6 14.4281 5.92917 14.0781 5.7875C13.7281 5.64583 13.4198 5.45 13.1531 5.2L6.12813 9.3C6.16146 9.41667 6.18229 9.52917 6.19063 9.6375C6.19896 9.74583 6.20312 9.86667 6.20312 10C6.20312 10.1333 6.19896 10.2542 6.19063 10.3625C6.18229 10.4708 6.16146 10.5833 6.12813 10.7L13.1531 14.8C13.4198 14.55 13.7281 14.3542 14.0781 14.2125C14.4281 14.0708 14.8031 14 15.2031 14C16.0365 14 16.7448 14.2917 17.3281 14.875C17.9115 15.4583 18.2031 16.1667 18.2031 17C18.2031 17.8333 17.9115 18.5417 17.3281 19.125C16.7448 19.7083 16.0365 20 15.2031 20ZM15.2031 18C15.4865 18 15.724 17.9042 15.9156 17.7125C16.1073 17.5208 16.2031 17.2833 16.2031 17C16.2031 16.7167 16.1073 16.4792 15.9156 16.2875C15.724 16.0958 15.4865 16 15.2031 16C14.9198 16 14.6823 16.0958 14.4906 16.2875C14.299 16.4792 14.2031 16.7167 14.2031 17C14.2031 17.2833 14.299 17.5208 14.4906 17.7125C14.6823 17.9042 14.9198 18 15.2031 18ZM3.20312 11C3.48646 11 3.72396 10.9042 3.91563 10.7125C4.10729 10.5208 4.20312 10.2833 4.20312 10C4.20312 9.71667 4.10729 9.47917 3.91563 9.2875C3.72396 9.09583 3.48646 9 3.20312 9C2.91979 9 2.68229 9.09583 2.49063 9.2875C2.29896 9.47917 2.20312 9.71667 2.20312 10C2.20312 10.2833 2.29896 10.5208 2.49063 10.7125C2.68229 10.9042 2.91979 11 3.20312 11ZM15.2031 4C15.4865 4 15.724 3.90417 15.9156 3.7125C16.1073 3.52083 16.2031 3.28333 16.2031 3C16.2031 2.71667 16.1073 2.47917 15.9156 2.2875C15.724 2.09583 15.4865 2 15.2031 2C14.9198 2 14.6823 2.09583 14.4906 2.2875C14.299 2.47917 14.2031 2.71667 14.2031 3C14.2031 3.28333 14.299 3.52083 14.4906 3.7125C14.6823 3.90417 14.9198 4 15.2031 4Z"
      fill="#BAB8B8"
    />
  </svg>
);


export {
  LikeIcon,
  NextIcon,
  PrevIcon,
  SaveIcon,
  ShareIcon
};